import Axios from 'axios';


const API_URL = process.env.REACT_APP_API_URL;

export const loginService = async (email, password) => {
    try {
        const doLogin = await Axios.post(`${API_URL}partnership/login`, {
            email,
            password
        });

        localStorage.setItem('token', doLogin.data.token);
        localStorage.setItem('userData', JSON.stringify(doLogin.data));

        return true;

    } catch (err) {
        return {
            error: true,
            response: err
        }
    }
}

export const logoutService = async () => {
    try {
        
        localStorage.removeItem('token');
        localStorage.removeItem('userData');

    } catch (err) {
        return {
            error: true,
            response: err.response
        }
    }
}